import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Checkbox, Form, Input, Modal, Select } from 'antd';
import { queryAccountList } from '@api/core/user';
import TagsInput from '@comm/TagsInput';
import DrawerOther from '@comm/orgStructure/orgStructure';

const FormItem = Form.Item;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewTypes: [],
      userList: [],
      checkedList: [
        { label: '全部', value: 0 },
        { label: '本公司人员', value: 1 },
        { label: '其他', value: 2 },
      ],
      views: [],
      types: [],
      DrawerVisible: false,
    };
  }

  componentDidMount() {
    const { views, types, viewTypes } = this.props.data;
    this.getAccountList();
    types &&
      types.map(item => {
        item.uid = item.uuid;
        return item;
      });
    this.setState({
      views: views || [],
      types: types || [],
      viewTypes: viewTypes || [],
    });
  }

  componentWillReceiveProps(nextProps) {
    const { views, types, viewTypes } = nextProps.data;
    if (nextProps.data !== this.props.data) {
      types &&
        types.map(item => {
          item.uid = item.uuid;
          return item;
        });
      this.setState({
        views: views || [],
        types: types || [],
        viewTypes: viewTypes || [],
      });
    }
  }

  getAccountList = () => {
    queryAccountList().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          userList: res.data,
        });
      }
    });
  };

  // 提交
  submit = () => {
    const { data } = this.props;
    const { viewTypes, views, types } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = {};
        data && data.uuid && (params.uuid = data.uuid);
        params.name = values.name;
        params.types = types;
        params.viewTypes = viewTypes;
        params.views = views;
        params.remark = values.remark;
        params.managerUuid = values.managerUuid;
        params.manager = values.manager;

        params.viewUsers = this.dealView(values.viewUsers);
        this.props.onOk(params);
        this.props.form.resetFields();
        // this.setState({
        //   viewTypes: [],
        //   types: this.props.data.types ? this.props.data.types : []
        // });
      }
    });
  };

  // 关闭
  onCancel = () => {
    this.props.form.resetFields();
    this.props.onCancel();
    this.setState({
      viewTypes: [],
      types: this.props.data.types ? this.props.data.types : [],
    });
  };

  // 查看权限改变
  checkedChange = list => {
    this.setState({
      viewTypes: list,
    });
  };

  // 设置资料库类型
  handleSetTags = types => {
    this.setState({ types });
  };

  handleManageChange = (value, option) => {
    this.props.form.setFieldsValue({ manager: option.props.children });
  };

  /* --------------- 其他权限详情---------------------------*/
  setViews = views => {
    this.setState({ views });
  };

  showDrawer = () => {
    this.setState({
      DrawerVisible: true,
    });
  };

  closeDrawer = () => {
    this.setState({
      DrawerVisible: false,
    });
  };

  dealView = users => {
    const params = [];
    const usersAll = this.state.userList;
    for (let i = 0; i < usersAll.length; i++) {
      for (let j = 0; j < users.length; j++) {
        if (usersAll[i].uuid === users[j]) {
          params.push(usersAll[i]);
        }
      }
    }
    return params;
  };

  /* --------------- 其他权限详情结束------------------------*/

  render() {
    const { data, visible, form, accountInfo } = this.props;
    const { getFieldDecorator } = form;
    const { userList, checkedList, viewTypes, DrawerVisible, views, types } = this.state;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    getFieldDecorator('manager', {
      initialValue: data.uuid ? data.manager : accountInfo.userName,
    });

    const viewUsersUuids = (data.viewUsers || []).filter(item => item).map(item => item.uuid);

    return (
      <Modal
        title={data.uuid ? '编辑资料库' : '创建资料库'}
        visible={visible}
        onOk={this.submit}
        onCancel={this.onCancel}
      >
        <Form>
          <FormItem label="资料库名称" {...formItemLayout}>
            {getFieldDecorator('name', {
              rules: [{ required: true, message: '请输入资料库名字' }],
              initialValue: data.name,
            })(<Input />)}
          </FormItem>
          <FormItem label="资料类型" {...formItemLayout}>
            <TagsInput tags={types} handleSetTags={this.handleSetTags} />
          </FormItem>
          <FormItem label="默认查阅权限" {...formItemLayout} style={{ marginBottom: '0' }}>
            {getFieldDecorator('viewTypes', {
              rules: [{ required: true, message: '请选择查阅类型' }],
              initialValue: data.viewTypes,
            })(<Checkbox.Group options={checkedList} onChange={this.checkedChange} />)}
            {viewTypes.some(item => +item === 2) ? (
              <a onClick={this.showDrawer} style={{ whiteSpace: 'nowrap' }}>
                其他权限详情
              </a>
            ) : null}
          </FormItem>

          <FormItem label="描述" {...formItemLayout} style={{ marginTop: '24px' }}>
            {getFieldDecorator('remark', {
              initialValue: data.remark,
            })(
              <Input.TextArea
                type="textarea"
                autosize={{ minRows: 3, maxRows: 9 }}
                placeholder="资料库介绍"
                maxLength={1000}
              />,
            )}
            <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
          </FormItem>
          <FormItem label="资料库管理员" {...formItemLayout}>
            {getFieldDecorator('managerUuid', {
              rules: [{ required: true, message: '请选择资料库管理员' }],
              initialValue: data.uuid ? data.managerUuid : this.props.accountInfo.userUuid,
            })(
              <Select
                onChange={this.handleManageChange}
                showSearch
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {userList.map(item => (
                  <Select.Option key={item.uuid} value={item.uuid}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </FormItem>
          <FormItem label="可以查看人员" {...formItemLayout}>
            {getFieldDecorator('viewUsers', {
              initialValue: viewUsersUuids,
            })(
              <Select
                mode="multiple"
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {userList.map(item => (
                  <Select.Option key={item.uuid} value={item.uuid}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>,
            )}
          </FormItem>
        </Form>
        {DrawerVisible ? (
          <DrawerOther
            onClose={this.closeDrawer}
            visible={DrawerVisible}
            views={views}
            setViews={this.setViews}
          />
        ) : null}
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(IndexModal));



// WEBPACK FOOTER //
// ./src/components/administrative/material/ModalAdd.js